"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOUCH_ACTIVATION = exports.MOUSE_ACTIVATION = void 0;
var MOUSE_ACTIVATION = exports.MOUSE_ACTIVATION = {
  CLICK: 'click',
  DOUBLE_CLICK: 'doubleClick',
  HOVER: 'hover',
  MOUSE_DOWN: 'mouseDown'
};
var TOUCH_ACTIVATION = exports.TOUCH_ACTIVATION = {
  DOUBLE_TAP: 'doubleTap',
  LONG_TOUCH: 'longTouch',
  TAP: 'tap',
  TOUCH: 'touch'
};